import { CombinedGraphQLErrors } from '@apollo/client/errors';

export default function getDescriptionFromError(error: unknown): string {
  if (!error) return '';
  const graphQLErrors = CombinedGraphQLErrors.is(error) ? error.errors : [];
  const messages = graphQLErrors.map(({ message }) => message);
  const message = error instanceof Error ? error.message : '';
  if (messages.length === 0) {
    return message;
  }
  return Array.from(new Set(messages)).join('\n');
}
